import { IResult, IRouteParam } from "../types";
import { getNotSubmitRevisionInformation } from "../utils";

const solveApproveHighlight = async (props: IRouteParam): Promise<IResult> => {
  const { currfileStepData, prevfileStepData } = props;
  // Extract all historical procedure save-in category IDs from step history
  const allHistorySavedInIds = currfileStepData.stepHistoryList.map((i) => i.procedureSaveInCategoryID);
  // Determine if there is a change in procedure saved-in category
  const isChangeProcedureSavedIn = new Set([...allHistorySavedInIds, currfileStepData.procedureSaveInCategoryID]).size > 1 || currfileStepData.isChangeProcedureSavedIn;
  // Extract all historical client server paths from step history
  const allHistoryPaths = currfileStepData.stepHistoryList.map((i) => i.clientServerPath);
  // Determine if there is a change in client server path
  const isChangeClientServerPath = new Set([...allHistoryPaths, currfileStepData.clientServerPath]).size > 1 || currfileStepData.isChangeClientServerPath;
  return {
    RevisionInformation: getNotSubmitRevisionInformation(props),
    ProcedureFiles: {
      ProcedureSavedIn: false,
      SavedInStatus:
        isChangeProcedureSavedIn && (prevfileStepData.procedureSaveInCategoryStatusID !== currfileStepData.procedureSaveInCategoryStatusID || !!currfileStepData.procedureSaveInCategoryReturnReason),
      ClientServerPath: false,
      ServerPathStatus: isChangeClientServerPath && (prevfileStepData.clientServerPathStatusID !== currfileStepData.clientServerPathStatusID || !!currfileStepData.clientServerPathReturnReason),
      LevelCChange: currfileStepData.isChangeLevelC !== prevfileStepData.isChangeLevelC,
      FileNameList: currfileStepData.procedureFiles
        .filter((curr) => {
          const prevFile = prevfileStepData.procedureFiles.find((prev: any) => prev.fileID === (curr.oldFileID ?? curr.fileID));
          if (!prevFile) return true;
          // Include file if: status changed, review status changed with return reason, or return reason was added/modified
          return prevFile.dataStatusID !== curr.dataStatusID || (prevFile.isReviewed && curr.returnReason) || (prevFile.returnReason !== curr.returnReason && curr.returnReason);
        })
        .map((i) => `file-${i.fileID}`),
    },
  };
};

export default solveApproveHighlight;
